import { BulkRescheduleAppointmentPage } from "./BulkRescheduleAppointmentPage";
export default BulkRescheduleAppointmentPage;
